import { Stack } from "@mantine/core";
import { PageHeader } from "components";
import PageContent from "components/layouts/PageContent";
import { FC } from "react";
import { SALES_ORDER_PAGE } from "routes/route.constant";
import { SALES_ORDER_PAGE_TITLE } from "../../config";
import SalesOrderCreateForm from "./components/SalesOrderCreateForm/SalesOrderCreateForm";

const CreateSalesOrder: FC = () => {
  return (
    <Stack gap="sm">
      <PageHeader
        breadcrumbs={[
          { title: SALES_ORDER_PAGE_TITLE, href: SALES_ORDER_PAGE },
          { title: "Tạo đơn bán hàng", href: "" },
        ]}
      />
      <PageContent>
        <SalesOrderCreateForm />
      </PageContent>
    </Stack>
  );
};

export default CreateSalesOrder;
